<template>
    <div class="n-pb-4">
        <div class="c-banner c-banner-small n-col-1 n-border-box n-overflow-hidden">
            <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage>

            <div class="c-banner-text n-col-1 n-p-3">
                <h1 class="n-c-1 c-max-width n-text-center n-m-auto n-mb-1 c-f-1 n-f-1">{{ LAN.welcome }}</h1>
            </div>
        </div>

        <div class="c-max-width n-m-auto n-mt-3 n-plr-2"
             v-if="isMobileByWinWidth">
            <a-row :gutter="[20, 0]"
                   class="n-flex-a-s">
                <a-col :span="24"
                       :lg="4"
                       style="padding: 0">
                    <div id="menu"
                         os="0"
                         class="n-bg-1">
                        <div class="n-plr-4 n-pt-3">
                            <h2 class="n-f-bold n-c-base c-title n-b-line n-t-line n-inline-block n-pb-1">{{
                                LAN.nav.QQOnlineShort }}</h2>
                        </div>
                        <div class="left-menu">
                            <div class="n-plr-4">
                                <ul class="n-p-0 n-ul n-m-0 n-pb-4 c-content-left">
                                    <li class="n-f-6 n-ptb-1 n-plr-2 n-pointer c-hover n-b-line">
                                        <router-link :to="{ name: 'journal' }"
                                                     class="c-tab-link n-c-4">{{
                                            LAN.nav.QQHome
                                            }}</router-link>
                                    </li>
                                    <li class="n-f-6 n-ptb-1 n-plr-2 n-pointer n-pointer c-hover n-b-line n-selected">
                                        {{ LAN.nav.QQOnlineShort }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </a-col>
                <a-col :span="24"
                       :lg="20">
                    <div class="n-bg-1 n-p-3">
                        <div v-if="loading">
                            <div class="n-skeleton n-skeleton-text n-mb-2"
                                 v-for="item in 20"
                                 :key="item"></div>
                        </div>

                        <div v-else-if="data.length > 0">
                            <ul class="n-ul n-p-0 n-m-0">
                                <li v-for="item in data"
                                    class="n-mb-2 n-f-6 c-hover-line c-hover"
                                    :key="item.id">
                                    <a :href="item.externalSiteUrl"
                                       target="_blank"
                                       v-if="item.onlyExternalPublish == 1"
                                       class="n-flex n-flex-a-c n-line-height-1 n-pointer c-tab-link n-c-4">
                                        {{ item.name }} ({{ item.nameAbbr }})
                                    </a>
                                    <router-link :to="{ name: 'journalPanel', query: { jid: item.id } }"
                                                 v-if="item.onlyExternalPublish == 0"
                                                 class="n-flex n-flex-a-c n-line-height-1 n-pointer c-tab-link n-c-4">
                                        {{ item.name }} {{ item.nameAbbr ? '(' + item.nameAbbr + ')' : '' }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>

                        <a-empty :description="LAN.journal.noJournal"
                                 v-else></a-empty>

                    </div>
                </a-col>
            </a-row>
        </div>

        <div class="c-max-width n-m-auto n-mt-3 n-plr-2"
             v-else>
            <a-row :gutter="[20, 0]"
                   class="n-flex-a-s">
                <a-col :span="24"
                       :lg="4"
                       style="padding: 0">
                    <div id="menu"
                         os="0"
                         class="n-bg-1">
                        <div class="n-plr-4 n-pt-3">
                            <h2 class="n-f-bold n-c-base c-title n-b-line n-t-line n-inline-block n-pb-1">{{
                                LAN.nav.QQOnlineShort }}</h2>
                        </div>
                        <div class="left-menu">
                            <div class="n-plr-4">
                                <ul class="n-p-0 n-ul n-m-0 n-pb-4 c-content-left">
                                    <li class="n-f-6 n-ptb-1 n-plr-2 n-pointer c-hover n-b-line">
                                        <router-link :to="{ name: 'journal' }"
                                                     class="c-tab-link n-c-4">{{
                                            LAN.nav.QQHome
                                        }}</router-link>
                                    </li>
                                    <li class="n-f-6 n-ptb-1 n-plr-2 n-pointer n-pointer c-hover n-b-line n-selected">
                                        {{ LAN.nav.QQOnlineShort }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </a-col>
                <a-col :span="24"
                       :lg="20">
                    <div class="n-bg-1 n-p-3">
                        <div v-if="loading">
                            <div class="n-skeleton n-skeleton-text n-mb-2"
                                 v-for="item in 20"
                                 :key="item"></div>
                        </div>

                        <div v-else-if="data.length > 0">
                            <div class="n-flex n-flex-a-c n-mb-5">
                                <h2 class="n-inline-block n-f-bold n-flex-g">{{ LAN.common.allJournalOnline }}</h2>

                                <div class="search-container n-flex n-flex-a-c n-pr-1 n-mb-2 n-ml-2">
                                    <a-input-search v-model:value="keyword"
                                                    enter-button
                                                    allowClear
                                                    size="large"
                                                    :placeholder="LAN.nui.common.pleaseEnterKeyword"
                                                    @search="searchData" />
                                </div>
                            </div>

                            <a-row :gutter="[16, 16]">
                                <a-col :span="12"
                                       :lg="8"
                                       v-for="item in data"
                                       :key="item.id">
                                    <div class="n-p-1 n-h-1">
                                        <a :href="item.externalSiteUrl"
                                           target="_blank"
                                           class="n-border-3 n-p-2 n-h-1 n-flex n-flex-dr-c n-pointer c-hover c-hover-border c-tab-link c-tab-link-event"
                                           v-if="item.onlyExternalPublish == 1">
                                            <div class="n-flex-g n-flex n-flex-a-c">
                                                <i class="n-icon n-icon-periodical n-icon-size-20"></i>
                                                <h4 class="n-break-word c-hover-target n-m-0 n-ml-2">{{ item.nameAbbr ?
                                                    '(' + item.nameAbbr + ') ' : '' }}{{ item.name }}
                                                </h4>
                                            </div>
                                        </a>

                                        <router-link :to="{ name: 'journalPanel', query: { jid: item.id } }"
                                                     class="n-border-3 n-p-2 n-h-1 n-flex n-flex-dr-c n-pointer c-hover c-hover-border c-tab-link c-tab-link-event"
                                                     v-if="item.onlyExternalPublish == 0">
                                            <div class="n-flex-g n-flex n-flex-a-c">
                                                <i class="n-icon n-icon-periodical n-icon-size-20"></i>
                                                <h4 class="n-break-word c-hover-target n-m-0 n-ml-2">{{ item.nameAbbr ?
                                                    '(' + item.nameAbbr + ') ' : '' }}{{ item.name }}
                                                </h4>
                                            </div>
                                        </router-link>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>

                        <a-empty :description="LAN.journal.noJournal"
                                 v-else></a-empty>

                    </div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import { StarOutlined, LikeOutlined, MessageOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue';
    import NImage from '@/components/nui/NImage/NImage.vue'

    import nui from '@/assets/script';

    export default {
        name: 'Journal',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                keyword: '',
                data: [],
                cache: []
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.loadData()
            },
            loadData () {
                this.loading = true;

                return this.request(this.API.journal, {
                    requestId: 'list',
                    params: { current: 1, size: 9999999, keyword: '' }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.cache = res.data.records.filter(item => item.isOnline == 1).sort((a, b) => a.name.substring(0, 1) >= b.name.substring(0, 1) ? 1 : -1)

                        this.searchData()
                    }
                    this.loading = false
                    this.$nextTick(() => {
                        this.parseMathJax()
                    })
                }).catch(err => {
                    this.loading = false
                })
            },
            searchData () {
                this.data = this.extend([], this.cache.filter(item => {
                    return item.name.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0 || item.nameAbbr.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0
                }))
            },
            goJournalLP (data) {
                if (data.isAnnualIssue == 1) {
                    this.$router.push({ name: 'bookSuccessionList', query: { id: data.serialId } })
                } else {
                    this.$router.push({ name: 'journalList', query: { id: data.id } })
                }
            }
        }),
        components: {
            StarOutlined,
            LikeOutlined,
            MessageOutlined,
            MenuUnfoldOutlined,
            NImage
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .category-button {
        display: none;
    }

    .c-title {
        display: block;

        &:before {
            width: 90%;
        }

        &:after {
            width: 100%;
        }
    }

    @media screen and (max-width: 1100px) {
        #menu {
            background-color: transparent;
        }

        .left-menu {
            display: none;
        }
    }
</style>